// mydatafeed/services/realtime.js
import connectWebSocket, {
  socket,
  closeWebSocket,
  runSimulation
} from "../websocket.js";

/** Garantiza que haya socket en modo realtime. */
export function ensureRealtimeSocket(simulationStart) {
  if (socket) return;
  if (simulationStart) {
    console.log("Starting simulation...");
    runSimulation();
  } else {
    connectWebSocket();
  }
}

/** Cierra WS si no hay suscriptores activos. */
export function closeRealtimeIfIdle(noSubscribers) {
  if (noSubscribers && socket) {
    closeWebSocket();
  }
}
